module.exports = __webpack_public_path__ + "static/img/rank_253.7ba5def.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_253.png
// module id = 7IRR
// module chunks = 1